import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Header from '../PartialViews/section-header';


const useStyles = makeStyles(() => ({
    icon: {
        backgroundColor: "#4c8ecb",
        color: "white",
        marginRight: "5px",
        padding: "5px"
    },
    button: {
        borderRadius: "30px",
        padding: "7px 50px",
        color: "#f5deb3",
        border: "2px solid #f5deb3",
        backgroundImage: "linear-gradient(to top, rgba(245, 222, 179, 0.3), rgba(76, 142, 203, 0.6))"
    }
}));

export default function Home() {
    
    const classes = useStyles();
    return (
        <>
            <Header>
                <Typography variant="h6" style={{color:"wheat", animatinoDelay:"0.1s", MozAnimationDelay: "0.1s", WebkitAnimationDelay: "0.1s"}} className={`${"wow"} ${"fadeInRight"}`}>Hi! I'm</Typography>
                <Typography variant="h3" style={{ marginLeft: "-3px", color:"white", animatinoDelay:"0.2s", MozAnimationDelay: "0.2s", WebkitAnimationDelay: "0.2s"}} className={`${"wow"} ${"fadeInRight"}`}><b>Ibiso Barimalaa</b></Typography>
                <Typography variant="overline" style={{color:"white", animatinoDelay:"0.3s", MozAnimationDelay: "0.3s", WebkitAnimationDelay: "0.3s"}} className={`${"wow"} ${"fadeInRight"}`}><b>Process Engineer and Full Stack Developer</b></Typography>
                <Box mb={1}>
                    <IconButton 
                        href="https://twitter.com/bid0706" 
                        target="_blank" 
                        className={`${classes.icon} ${"wow"} ${"hinge"} ${"rollIn"}`} 
                        style={{animatinoDelay:"0.4s", MozAnimationDelay: "0.4s", WebkitAnimationDelay: "0.4s"}}
                        size="small">
                        <TwitterIcon />
                    </IconButton>
                    <IconButton 
                        href="https://instagram.com/bid0706" 
                        target="_blank" 
                        className={`${classes.icon} ${"wow"} ${"hinge"} ${"rollIn"}`} 
                        style={{animatinoDelay:"0.2s", MozAnimationDelay: "0.2s", WebkitAnimationDelay: "0.2s"}}
                        size="small">
                        <InstagramIcon />
                    </IconButton>
                    <IconButton 
                        href="https://facebook.com/barimalaa.i.ibiso" 
                        target="_blank" 
                        className={`${classes.icon} ${"wow"} ${"hinge"} ${"rollIn"}`} 
                        style={{animatinoDelay:"0.5s", MozAnimationDelay: "0.5s", WebkitAnimationDelay: "0.5s"}}
                        size="small">
                        <FacebookIcon />
                    </IconButton>
                </Box>
                <Box mt={3}>
                    <Button 
                        variant="outlined"
                        component={Link} to="/about" 
                        className={`${classes.button} ${"wow"} ${"rubberBand"}`} 
                        style={{animatinoDelay:"0.5s", MozAnimationDelay: "0.5s", WebkitAnimationDelay: "0.5s"}}
                        disableElevation
                        >Learn more</Button>
                </Box>
                
            </Header>
        </>
    )
}